import { render, staticRenderFns } from "./asiakirjat-upload.vue?vue&type=template&id=6248806d&scoped=true&"
import script from "./asiakirjat-upload.vue?vue&type=script&lang=ts&"
export * from "./asiakirjat-upload.vue?vue&type=script&lang=ts&"
import style0 from "./asiakirjat-upload.vue?vue&type=style&index=0&id=6248806d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6248806d",
  null
  
)

export default component.exports